export default "__VITE_ASSET__DpL2ndF7__"